document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('select[name="id"]'); // ajusta el selector si es necesario
  if (!select) return;

  const options = Array.from(select.options);
  if (options.length !== 3) return; // solo actúa si hay exactamente 3 variantes

  // Ocultar el select original
  select.style.display = 'none';

  // Crear contenedor de tarjetas
  const container = document.createElement('div');
  container.className = 'variant-cards';

  options.forEach((opt, i) => {
    const card = document.createElement('div');
    card.className = 'variant-card';
    card.textContent = opt.text;
    card.dataset.value = opt.value;

    if (i === 0) {
      card.classList.add('selected');
      select.value = opt.value;
    }

    card.addEventListener('click', function () {
      document.querySelectorAll('.variant-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      select.value = card.dataset.value;
      select.dispatchEvent(new Event('change'));
    });

    container.appendChild(card);
  });

  select.parentNode.insertBefore(container, select);
});
